.root {
    position: relative;
    aspect-ratio: 253/129;
    overflow: hidden;
    z-index: 1;
    mix-blend-mode: multiply;

    svg {
        position: absolute;
        width: 100%;
        height: 100%;
        fill: #333;
        animation: pulse 4s ease-in-out infinite;
    }
}

@keyframes pulse {
    0% {
        scale: 0.85;
    }

    50% {
        scale: 1;
    }

    100% {
        scale: 0.85;
    }
}
